import {DialogEngine, DialogConfirmConfig} from "@shared/libs/dialog";
import { Dialog } from 'vant';

class DialogEngineVant implements DialogEngine {
    confirm(config: DialogConfirmConfig): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            Dialog.confirm({
                title: config.title,
                message: config.content,
                cancelButtonText: config.cancelText,
                confirmButtonText: config.okText,
            }).then(() => {
                resolve();
            }).catch(() => {
                reject();
            })
        });
    }
}

export default DialogEngineVant;
